import $ from "jquery";

/* global tinyMCE */

$(document).on("turbolinks:load", function() {
  // "insertvisualization" is the name of the plugin referenced in tinymce.yml
  if (!window.tinyMCEPluginList) {
    window.tinyMCEPluginList = [];
  }

  window.tinyMCEPluginList.push([
    "insertvisualization",
    function(editor) {
      /* DIALOG WINDOW */

      var openDialog = function () {
        return editor.windowManager.open({
          title: "Insert a visualization",
          body: [
            {
              type: "textbox",
              name: "visualization_string",
              label: "Enter the widget name(must match 'Widget name' field in chart form below)"
            }
          ],
          buttons: [
            {
              text: "Cancel",
              onclick: "close"
            },
            {
              text: "Save",
              onclick: "submit"
            }
          ],
          onsubmit: function (api) {
            var data = api.data.visualization_string;
            // remove any '(' or ')' from the entered string
            const visualizationName = data;
            const randomId = Math.floor(Math.random() * 1000);
            const content = `
              <div class="mceEditable inserted-visualization-wrapper">
                <div class="inserted-visualization mceNonEditable">
                  <div class="visualization-badge mceNonEditable">
                    <div class="mceEditable inserted-visualization-name" id="visualization-${randomId}">${visualizationName}</div>
                  </div>
                </div>
              </div>
              <p>
                <span></span>
              </p>
            `.replace(/>\s*/gi, ">").replace(/\s*</gi, "<");
            editor.insertContent(content);
          }
        });
      };

      /* EDITOR FUNCTIONS */

      // Don't allow some key presses
      editor.on("keydown", function(e) {
        const el = tinyMCE.activeEditor.selection.getNode();
        if ($(el).closest(".inserted-visualization-name").length > 0) {
          // Enter key
          if (e.keyCode === 13) {
            const insertAbove = e.shiftKey;

            // prevent newlines inside the visualization entry filed
            e.preventDefault();
            // add empty <p></p> to top or bottom of editor
            const $wrapper = $(el).closest(".inserted-visualization-wrapper");
            let $insertedParagraph;
            if (insertAbove) {
              $wrapper.before("<p><br data-mce-bogus='1'></p>");
              $insertedParagraph = $(el).closest(".inserted-visualization-wrapper").prev();
            } else {
              $wrapper.after("<p><br data-mce-bogus='1'></p>");
              $insertedParagraph = $(el).closest(".inserted-visualization-wrapper").next();
            }

            // focus cursor to this empty <p></p>
            tinyMCE.activeEditor.selection.select($insertedParagraph[0], true);
            tinyMCE.activeEditor.selection.collapse(false);
          }
        }
      });

      editor.on("keyup", function() {
        // no longer storing the name in a data-attr
      });

      /* HELPER FUNCTIONS */

      // Disable the button when we are in an inserted visualization node (so user can't put an visualization inside an visualization)
      // TODO: find a way to disable the menu item (or remove that menu item completely, is it necessary?)
      function monitorNodeChange() {
        const btn = this;
        editor.on("NodeChange", function(e) {
          btn.disabled(
            e.element.classList.contains("inserted-visualization-name") ||
            e.element.parentElement.classList.contains("inserted-visualization-name")
            );
        });
      }

      // Remove an visualization completely
      function deleteVisualization() {
        const el = tinyMCE.activeEditor.selection.getNode();
        const wrapper = $(el).closest(".inserted-visualization-wrapper");
        wrapper.remove();
      }

      /* REGISTER BUTTONS */

      // Add a toolbar button that opens the dialog
      // add insertvisualizationbutton to toolbar in tinymce.yml to show it
      editor.addButton("insertvisualizationbutton", {
        text: "Insert visualization",
        icon: "image",
        tooltip: "Open a modal and enter a widget name for the visualization you want to insert(must match a 'Widget name' field in chart form below)",
        onclick: openDialog,
        onpostrender: monitorNodeChange
      });

      // Add a button to the insert menu
      editor.addMenuItem("insertvisualizationbutton", {
        text: "Insert visualization from file",
        icon: "image",
        context: "insert", // this is the name of the dropdown menu in which it will be placed
        onclick: openDialog
      });

      // Add a delete button inside the context toolbar
      editor.addButton("deletevisualization", {
        text: "Delete",
        icon: "remove",
        onclick: deleteVisualization
      });

      /* CONTEXT TOOLBAR */

      // add a context toolbar when we click inside the editing area
      editor.addContextToolbar("div.inserted-visualization-name", "deletevisualization");
    },
  ]);
});
